import { PropsWithChildren, useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { FilterQueryContextProvider } from 'src/contexts/FilterQueryContext';
import { ReportMetricsContextProviderV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import { ReportConfigV2 } from 'src/hooks/reportConfigs';
import { EmptyReportV2SoldTicketQuery } from 'src/utils/eventQueryUtils';
import {
  ReportV2Client,
  UIReportV2SoldTicketQuery,
} from 'src/WebApiController';

export function ReportsSoldTicketContextProviderV2({
  reportConfig,
  isExport,
  children,
}: PropsWithChildren<{
  reportConfig: ReportConfigV2;
  isExport?: boolean;
}>) {
  const { activeAccountWebClientConfig } = useAppContext();

  const getReportMetrics = useCallback(
    (
      tempReportConfig: ReportConfigV2,
      filters: UIReportV2SoldTicketQuery,
      pageNumber: number
    ) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getSoldTicketReportMetrics({
        ...tempReportConfig.request,
        pageNumber,
        filters,
        metadata: {
          reportConfigId: tempReportConfig.reportId,
        },
      });
    },
    [activeAccountWebClientConfig]
  );

  const getReportMetricsSummary = useCallback(
    (tempReportConfig: ReportConfigV2, filters: UIReportV2SoldTicketQuery) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getSoldTicketReportSummary({
        ...tempReportConfig.request,
        filters,
        metadata: {
          reportConfigId: tempReportConfig.reportId,
        },
      });
    },
    [activeAccountWebClientConfig]
  );

  return (
    <FilterQueryContextProvider<UIReportV2SoldTicketQuery>
      initialQuery={reportConfig.request.filters as UIReportV2SoldTicketQuery}
      emptyQuery={EmptyReportV2SoldTicketQuery}
      loadQueryFromUrl={false}
    >
      <ReportMetricsContextProviderV2<UIReportV2SoldTicketQuery>
        queryKey="getReportSoldTicketMetricsV2"
        getReportMetrics={getReportMetrics}
        getReportMetricsSummary={getReportMetricsSummary}
        disabled={isExport}
        reportConfig={reportConfig}
      >
        {children}
      </ReportMetricsContextProviderV2>
    </FilterQueryContextProvider>
  );
}
